import { CompactProfileV2, ProfileV2 } from '../../types';

function isApproachable({
  approachabilitySignal,
}: CompactProfileV2 | ProfileV2): boolean {
  return approachabilitySignal ? approachabilitySignal === 2 : false;
}

export default isApproachable;
